import { mapGetters, mapActions } from 'vuex';
import { apiMixin } from 'relapp-api';
import { pageLoadingStatusMixin } from 'relapp-loading';
import trackingMixin from './tracking.js';
import productsMixin from './products.js';

export default {
    mixins: [productsMixin, apiMixin, pageLoadingStatusMixin, trackingMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            productType: null
        };
    },
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getServicesByDomain: 'services/servicesByDomain',
            user: 'user/user',
            currentCustomer: 'user/currentCustomer',
            orderDomains: 'order/domains',
            orderTotalPrice: 'order/totalPrice',
            getOrderLineItem: 'order/service'
        }),
        /**
         * Get the ssl, if any, ordered with the domain.
         *
         * @return {object}
         */
        orderedService() {
            if (!this.productType || !this.domain) {
                return;
            }

            return this.getOrderLineItem({
                type: this.productType,
                domain: this.domain
            });
        },
        /**
         * Get the customer by domain from the services.
         *
         * @return {integer}
         */
        getCustomer() {
            if (
                !this.currentCustomer ||
                !this.getServicesByDomain[this.domain] ||
                this.getServicesByDomain[this.domain][0].customer_id == this.currentCustomer.id
            ) {
                return;
            }

            return this.getServicesByDomain[this.domain][0].customer_id;
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
    },
    methods: {
        ...mapActions({
            resetOrder: 'order/reset',
            setCustomer: 'order/setCustomer',
            sendOrder: 'order/send'
        })
    }
};
